import React, { useState } from "react";
import AuthorGrouping from "../components/FrontMatter/AuthorGrouping";
import Affiliation from "../components/FrontMatter/Affiliation";
import Keywords from "../components/FrontMatter/Keywords";

const FrontMatter = ({ show, handleCancel, editor }) => {
  const [isVisible, setIsVisible] = useState(true);
  return (
    <div className="w-fit h-fit z-[100] right-0">
      {show.authorgrouping && (
        <AuthorGrouping
          handleCancel={handleCancel}
          editor={editor}
          show={show.authorgrouping}
        />
      )}
      {show.affiliation && (
        <Affiliation
          handleCancel={handleCancel}
          editor={editor}
          show={show.affiliation}
        />
      )}
      {show.keywords && (
        <Keywords
          handleCancel={handleCancel}
          editor={editor}
          show={show.keywords}
        />
      )}
    </div>
  );
};

export default FrontMatter;
